import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './supplierActionTypes';
import * as actions from './supplierActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.getSupplier, action.payload);
    yield put(actions.getSupplierSuccess(data));
  } catch (e) {
    yield put(actions.getSupplierError(e));
  }
}

function* addSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.addSupplier, action.payload);
    yield put(actions.addSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/suppliers');
        }, 1500);
      }
    }
  } catch (e) {
    yield put(actions.addSupplierError(e));
  }
}

function* updateSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.updateSupplier, action.payload);
    yield put(actions.updateSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/suppliers');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateSupplierError(e));
  }
}

function* deleteSupplierSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteSupplier, action.payload);
    yield put(actions.deleteSupplierSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Tedarikçi başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getSupplierRequest({}));
    }
  } catch (e) {
    yield put(actions.deleteSupplierError(e));
  }
}

function* watchGetSupplier() {
  yield takeEvery(types.GET_SUPPLIER_REQUEST, getSupplierSaga);
}
function* watchAddSupplier() {
  yield takeEvery(types.ADD_SUPPLIER_REQUEST, addSupplierSaga);
}
function* watchUpdateSupplier() {
  yield takeEvery(types.UPDATE_SUPPLIER_REQUEST, updateSupplierSaga);
}
function* watchDeleteSupplier() {
  yield takeEvery(types.DELETE_SUPPLIER_REQUEST, deleteSupplierSaga);
}

export function* supplierSaga() {
  yield all([
    watchGetSupplier(),
    watchAddSupplier(),
    watchUpdateSupplier(),
    watchDeleteSupplier(),
  ]);
} 